import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { RecipientValidationCodes } from '../models/recipient-validation-codes';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RecipientValidationCodesEntityService extends BaseEntityService<RecipientValidationCodes> {
  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, {
        singular: 'recipientValidationCode',
        plural: 'recipientValidationCodes',
        url: 'recipient-validation-codes'
      },
      routerParamsService
    );
    this.nameId = 'recipientValidationCodeId';
  }


  getRecipientValidationCodes(recipientValidationCode: RecipientValidationCodes, token: string): Observable<RecipientValidationCodes> {
    const headers = new HttpHeaders({
      'X-Google-Recaptcha-Token': token
    });

    return this.httpClient
      .post(`${ this.entityUrl }`, { recipientValidationCode }, { headers })
      .pipe(map((response: any) => response));

  }
}
